import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import { useTranslation } from 'react-i18next';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import Timer from '../Shared/Timer';
import Popover from '@material-ui/core/Popover';
import ChangeStatePopoverContent from '../Shared/ChangeStatePopoverContent';
import { toast } from 'react-toastify';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import StopCarpentryOrderDialog from '../Shared/Dialogs/StopCarpentryOrderDialog';
import FinishCarpentryOrderDialog from '../Shared/Dialogs/FinishCarpentryOrderDialog';
import CredentialsPloegChefDialog from '../Shared/Dialogs/CredentialsPloegChefDialog';
import { dataService } from '../../Services/data.service';
import Box from '@material-ui/core/Box';

export default function CarpentryOrderState(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [credentialsDialogOpen, setCredentialsDialogOpen] = useState(false);
    const [stopOrderDialogOpen, setStopOrderDialogOpen] = useState(false);
    const [finishOrderDialogOpen, setFinishOrderDialogOpen] = useState(false);
    const [productionOrder] = useState(props.productionOrder);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const closeCredentialsDialog = () => {
        setCredentialsDialogOpen(false)
    }

    const openPopover = (event) => {
        if (props.productionOrder.productionOrderStatus !== state.STOPPED && props.productionOrder.productionOrderStatus !== state.DONE) {
            setAnchorEl(event.currentTarget);
        }
    };

    const changeOrderState = (orderState) => {

        if (orderState === state.STOPPED) {
            setAnchorEl(null);
            setDialogTitle(t("Provide a reason why this order is being stopped"));
            setDialogContext(t("This can not be made undone!"));
            setStopOrderDialogOpen(true);
        }
        else if (orderState === state.PAUSED) {
            dataService.pauseProductionOrderLine(props.productionOrder.productionOrderLineId, props.user.packer).then(setTimeout(() => { props.actions.setSelectedZone(null); props.refreshOrders(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) });
            setAnchorEl(null);
        }
        else if (orderState === state.RUNNING) {
            dataService.startProductionOrderLine(props.productionOrder.productionOrderLineId, props.productionOrder.machineId, props.user.packer).then(setTimeout(() => { props.refreshOrders(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) });
            setAnchorEl(null);
        }
        else if (orderState === state.DONE) {
            setAnchorEl(null);
            setDialogTitle(t("Zijn al de gevraagde") + props.productionOrder.quantity + t("exemplaren van deze pallet gemaakt?"));
            setFinishOrderDialogOpen(true);
        }
    }

    const stopOrder = (stopComment, reasonId) => {
        if (reasonId === "" && stopComment === "") {
            toast.error("Please fill in a reason", { position: "top-center" });
            return;
        }

        if ((!props.user.isPloegchef && !props.user.isAdministrator)) {
            setDialogTitle("ENTER CREDENTIALS PLOEGCHEF");
            setCredentialsDialogOpen(true);
        }
        else {
            dataService.stopProductionOrderLine(props.productionOrder.productionOrderLineId, props.productionOrder.machineId, reasonId, stopComment, props.user.packer).then(setTimeout(() => { props.refreshOrders(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) });
        }
    }

    const finishOrder = () => {
        setFinishOrderDialogOpen(false);
        dataService.finishProductionOrderLine(props.productionOrder.productionOrderLineId, props.user.packer).then(setTimeout(() => { props.refreshOrders(); }, 2000)).catch((error) => { toast.error(error, { position: "top-center" }) });
    }

    let stateIcon = <React.Fragment></React.Fragment>;
    switch (props.productionOrder.productionOrderStatus) {
        case state.RUNNING:
            stateIcon = <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>;
            break;
        case state.PAUSED:
            stateIcon = <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>;
            break;
        case state.STOPPED:
            stateIcon = <div className={classes.stop}></div>;
            break;
        case state.DONE:
            stateIcon = <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done.svg'}></img>
            break;
        case state.PLANNED:
            stateIcon = <img className={classes.planned} alt="planned" src={process.env.PUBLIC_URL + '/img/planned.svg'}></img>
            break;
        default:
    }

    let pausedOrRunning = productionOrder.productionOrderStatus === state.RUNNING || productionOrder.productionOrderStatus === state.PAUSED
    let planned = productionOrder.productionOrderStatus === state.PLANNED
    let showElapsed = productionOrder.productionOrderStatus === state.PAUSED || productionOrder.productionOrderStatus === state.RUNNING


    return <div className={classes.orderState} style={{ backgroundColor: productionOrder.productionOrderStatusForegroundColor + "44", cursor: ((pausedOrRunning || planned)) && "pointer" }}>
        <div className={classes.stateContainer} onClick={(e) => openPopover(e)} >
            <button className={classes.popoverButton} style={{ cursor: ((pausedOrRunning || planned)) && "pointer" }}>
                <div className={classes.centerState}>
                    <div className={classes.state} style={{ paddingTop: showElapsed ? "0px" : "3px" }}>
                        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {t(props.productionOrder.productionOrderStatus)}
                                {(props.productionOrder.productionOrderStatus === state.STOPPED || props.productionOrder.productionOrderStatus === state.DONE) ?
                                    <React.Fragment></React.Fragment>
                                    : <ExpandMoreIcon className={classes.expandStatesIcon}></ExpandMoreIcon>
                                }
                            </Box>
                            {showElapsed ?
                                <div className={classes.elapsed}><Timer startTime={productionOrder.startedOn} {...props}></Timer></div>
                                : <React.Fragment></React.Fragment>
                            }
                        </Box>
                    </div>
                </div>
            </button>
            <div className={classes.icon}>{stateIcon}</div>

        </div>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <ChangeStatePopoverContent {...props} isCarpentryOrder={true} state={props.productionOrder.productionOrderStatus} changeState={changeOrderState} popoverWidth={"15vw"}></ChangeStatePopoverContent>
        </Popover>
        <CredentialsPloegChefDialog dialogTitle={dialogTitle} dialogContext={dialogContext} dialogOpen={credentialsDialogOpen} closeDialog={closeCredentialsDialog} action={stopOrder}> </CredentialsPloegChefDialog>
        <StopCarpentryOrderDialog {...props} dialogOpen={stopOrderDialogOpen} action={stopOrder} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setStopOrderDialogOpen(false)} ></StopCarpentryOrderDialog>
        <FinishCarpentryOrderDialog {...props} dialogOpen={finishOrderDialogOpen} action={finishOrder} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setFinishOrderDialogOpen(false)} ></FinishCarpentryOrderDialog>

    </div>
}

const useStyles = makeStyles({
    orderState: {
        marginLeft: "10px",
        float: "left",
        width: "10%",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        borderRadius: "0px 6px 6px 0px",
    },
    centerState: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        height: "100%",
        width: "100%",
    },
    stateContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        overflow: "hidden",
        justifyContent: 'center',
        height: '100%'
    },
    svg: {
        float: "left",
    },
    play: {
        color: "#5CC958",
        height: "60px",
        width: "60px"
    },
    stop: {
        height: "30px",
        width: "30px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px",
        marginLeft: "auto",
        marginRight: "auto",
    },
    pause: {
        height: "50px",
        width: "50px",
        color: "#F59127",
    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
    },
    planned: {
        paddingTop: "5px",
        height: "35px"
    },
    done: {
        paddingTop: "10px",
    },
    state: {
        textTransform: "uppercase",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block"
    },
    icon: {
        paddingTop: '15px'
    },
    expandStatesIcon: {
        float: "left",

        color: FlagstoneTheme.palette.primary.main
    },
    elapsed: {
        fontSize: "10px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block"
    },
    popoverButton: {
        border: "none",
        outline: "none",
        padding: '0px',
        width: '100%',
        backgroundColor: "rgba(1,1,1,0)"
    },
});